/**
 * Load Google Ads functions
 * */

(function (pmw, $, undefined) {


	pmw.getGoogleAdsConversionIdentifiersWithLabel = () => {

		let conversionIdentifiers = []

		if (pmwDataLayer?.pixels?.google?.ads?.conversion_ids) {
			Object.entries(pmwDataLayer.pixels.google.ads.conversion_ids).forEach(([key, item]) => {
				if (item) {
					// Check if item is an array (multiple labels for the same conversion_id)
					if (Array.isArray(item)) {
						item.forEach((label) => {
							if (label) {
								conversionIdentifiers.push(key + "/" + label)
							}
						})
					} else {
						conversionIdentifiers.push(key + "/" + item)
					}
				}
			})
		}

		return conversionIdentifiers
	}

	pmw.getGoogleAdsConversionIdentifiers =  () => {

		let conversionIdentifiers = []

		Object.keys(pmwDataLayer.pixels.google.ads.conversion_ids).forEach((key) => {
			conversionIdentifiers.push(key)
		})

		return conversionIdentifiers
	}

	pmw.getGoogleAdsRegularOrderItems = () => {

		let orderItems = []

		Object.values(pmwDataLayer.order.items).forEach((item) => {

			let orderItem

			orderItem = {
				quantity                : item.quantity,
				price                   : item.price_tax_excluded,
				google_business_vertical: pmwDataLayer.pixels.google.ads.google_business_vertical,
			}

			if (pmwDataLayer?.shop?.variations_output && 0 !== item.variation_id) {

				orderItem.id = String(pmwDataLayer.products[item.variation_id].dyn_r_ids[pmwDataLayer.pixels.google.ads.dynamic_remarketing.id_type])
				orderItems.push(orderItem)
			} else {

				orderItem.id = String(pmwDataLayer.products[item.id].dyn_r_ids[pmwDataLayer.pixels.google.ads.dynamic_remarketing.id_type])
				orderItems.push(orderItem)
			}
		})

		return orderItems
	}

}(window.pmw = window.pmw || {}, jQuery))
